export default __webpack_public_path__ + "static/media/accommodation.524e7dcb.svg";